import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import mvtSocial from '@/common/components/mvtsocial/mvt-social.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { setStorage } from '../../utilities/nojq/_localstorage.js';
import { getMembershipFormInfo } from './mvt-authenticate-info.js';

export default {
    name: 'mvtCheckEmail',
    inject: ['$eventBus'],
    props: {
        options: {
            type: Object,
            default: {
                title: null,
                buttonText: null,
                trigger: '',
                subTitle: null,
                icon: '',
                hideProfile: false,
                propertyData: null,
            },
        },
    },
    components: {
        mvtTextbox,
        mvtSocial,
    },
    data() {
        return {
            email: '',
        };
    },
    mounted() {
        if (!this.glb.user.id) {
            setStorage('pendingRequestName', this.options.requestName);
        }
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        formInfo() {
            var formInfo = getMembershipFormInfo({
                requestName: this.options.requestName,
                trigger: this.options.trigger,
                geoZip: this.glb.geo && this.glb.geo.zipcode,
            });

            if (this.options.buttonText) {
                formInfo.buttonText = this.options.buttonText;
            }
            if (this.options.propertyData) {
                formInfo.propertyData = this.options.propertyData;
            }
            if (this.options.termsHtml) {
                formInfo.termsHtml = this.options.termsHtml;
            }
            if (!formInfo.benefits.length) {
                if (this.options.title) {
                    formInfo.title = this.options.title;
                }
                if (this.options.subTitle) {
                    formInfo.desc = this.options.subTitle;
                }
            }
            return formInfo;
        },
    },
    methods: {
        ...mapActions('glb', ['login', 'checkUserByEmailId']),
        ...mapMutations('glb', ['updateUserInfo']),
        switchComponent(name) {
            this.$emit('switchComponent', name);
        },
        submitSignup() {
            this.$eventBus.$emit('eventbus-submit-signup', { email: this.email, requestName: this.options.requestName || '' });
        },
    },
};
